import { SystemFieldNames, SystemFieldGroups, getTreatmentGroupsTitle, getTreatmentGroupsDescription, INDEPENDENT_VARIABLES } from './systemFieldConstants'
import { fieldDetails as irrigationTimingControlGroup } from './irrigationTimingControlGroup'

import type { QField } from '~/features/questionnaire/types'
import type { SystemFieldDetails } from './systemFieldConstants'

const
  independentVariable = INDEPENDENT_VARIABLES.IRRIGATION_TIMING,
  schemaEntry: QField = {
    fieldName: SystemFieldNames.irrigationTimingTreatmentGroups,
    fieldType: 'COLLECTION',
    visibleWhen: irrigationTimingControlGroup.schemaEntry.visibleWhen,
    format: irrigationTimingControlGroup.schemaEntry.format
  },
  fieldDetails: SystemFieldDetails = {
    fieldName: SystemFieldNames.irrigationTimingTreatmentGroups,
    variableGroup: SystemFieldGroups.EXP_DESIGN,
    isRequired: true,
    title: getTreatmentGroupsTitle(independentVariable),
    description: getTreatmentGroupsDescription(independentVariable),
    treatmentGroupsFor: independentVariable,
    schemaEntry
  }

export {
  fieldDetails
}
